/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { REHYDRATE } from 'redux-persist';

const defaults = {
  isFetching: false,
  error: null,
  data: null,
  timestamp: 0,
};

export interface StateType {
  /* false - default. true - Ajax Request in progress */
  isFetching: boolean;
  /* null - default. value of type string - Error Response from Ajax Request */
  error?: string;
  /* null - default. value of type Array<Object> from Ajax Request */
  data?: Array<Object>;
  /** timestamp of last update */
  timestamp: number;
}

export interface ActionType {
  type: string;
  payload: any;
}

/*
    getReducer - Helper method to generate Reducer dynamically. Useful for Handling Ajax Requests.
*/
class ReduxGenerator {
  static getReducer(actionName: string, reducerName: string) {
    const requestType = `${actionName.toUpperCase()}_REQUEST`;
    const successType = `${actionName.toUpperCase()}_SUCCESS`;
    const failedType = `${actionName.toUpperCase()}_FAILURE`;
    return (state: StateType, action: ActionType) => {
      const timestamp = new Date().getTime();
      switch (action.type) {
        case requestType:
          return { ...state, ...defaults, isFetching: true, timestamp };
        case successType:
          return { ...state, ...defaults, data: { ...action.payload }, timestamp };
        case failedType:
          return { ...state, ...defaults, error: action.payload, timestamp };
        case REHYDRATE:
          if (action.payload && action.payload[reducerName]) {
            return {
              ...defaults,
              ...action.payload[reducerName],
              timestamp
            };
          }
          return {
            ...defaults,
          };
        default:
          return { ...state };
      }
    };
  }
}

export default ReduxGenerator;
